<div class="card-header bg-light">
  <h4 class="card-title mb-0">Avaliar Manifestação do Auditado</h4>
  <button type="button" class="close" (click)="fechar()">
    <span>&times;</span>
  </button>
</div>

<div class="card-body wrapper">
  <form [formGroup]="form" #f="ngForm" id="avaliacao-manifestacao">

    <!-- Seção de Avaliação -->
    <div class="row p-2">
      <div class="col-12">
        <label class="form-label"><strong>Avaliação *</strong></label>
      </div>

      <div class="col-auto form-check me-4">
        <input class="form-check-input" type="radio"
               id="radioAcatadas"
               value="com_sugestoes_acatadas"
               formControlName="avaliacaoTipo">
        <label class="form-check-label" for="radioAcatadas">
          Com Sugestões Acatadas
        </label>
      </div>

      <div class="col-auto form-check me-4">
        <input class="form-check-input" type="radio"
               id="radioNaoAcatadas"
               value="com_sugestoes_nao_acatadas"
               formControlName="avaliacaoTipo">
        <label class="form-check-label" for="radioNaoAcatadas">
          Com Sugestões NÃO Acatadas
        </label>
      </div>

      <div class="col-auto form-check">
        <input class="form-check-input" type="radio"
               id="radioSemSugestoes"
               value="sem_sugestoes"
               formControlName="avaliacaoTipo">
        <label class="form-check-label" for="radioSemSugestoes">
          Sem Sugestões
        </label>
      </div>

      <div *ngIf="f.submitted && form.controls['avaliacaoTipo'].invalid" class="col-12 text-danger mt-2">
        <small>Campo obrigatório</small>
      </div>
    </div>

    <!-- Seção de Comentário -->
    <div class="row col-12 p-2">
      <label class="form-label"><strong>Comentário *</strong></label>
      <textarea type="text"
                class="form-control"
                rows="4"
                formControlName="comentario"
                maxlength="500"
                placeholder="Digite seu comentário..."
                [ngClass]="{ 'is-invalid': f.submitted && form.controls['comentario'].invalid }">
      </textarea>

      <div class="d-flex justify-content-between mt-1">
        <div *ngIf="f.submitted && form.controls['comentario'].invalid" class="invalid-feedback d-block">
          <div *ngIf="form.controls['comentario'].errors?.required">Campo obrigatório</div>
        </div>
        <small class="text-muted ms-auto">
          {{ form.get('comentario').value?.length || 0 }} / 500
        </small>
      </div>
    </div>

  </form>
</div>

<div class="card-footer">
  <button type="submit"
          class="btn btn-success btn-sm mr-1"
          form="avaliacao-manifestacao"
          (click)="avaliar()"
          [disabled]="loading">
    <i class="fas fa-check"></i> Avaliar
  </button>

  <button type="button"
          class="btn btn-danger btn-sm"
          (click)="fechar()">
    <i class="fas fa-times"></i> Cancelar
  </button>
</div>
